export const CONTACT_EMAIL_ADDRESS = 'health.covid19@state.mn.us'
